const Footer = () => {
    return (
      <footer className="text-center text-gray-500 text-sm mt-4">
        &copy; 2002 - 2025 Comon Professionals Pty. Ltd. All rights reserved. Alfa 0.20.2v
      </footer>
    );
  };
  
  export default Footer;
  